const configuredBaseUrl = process.env.REACT_APP_BASE_URL;

export const baseUrl =
  configuredBaseUrl === undefined
    ? "https://app-limo.kenshinsystems.com"
    : configuredBaseUrl.replace(/\/$/, "");


// const configuredBaseUrl = process.env.REACT_APP_BASE_URL;
// export const baseUrl =
//   configuredBaseUrl === undefined
//     ? "http://localhost:9090"
//     : configuredBaseUrl.replace(/\/$/, "");
